var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMoreHorizonLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8499 6.80039C10.8499 7.43552 11.3648 7.95039 11.9999 7.95039C12.635 7.95039 13.1499 7.43552 13.1499 6.80039C13.1499 6.16526 12.635 5.65039 11.9999 5.65039C11.3648 5.65039 10.8499 6.16526 10.8499 6.80039Z",
    fill: "#121619"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8498 17.2008C10.8498 17.8359 11.3647 18.3508 11.9998 18.3508C12.6349 18.3508 13.1498 17.8359 13.1498 17.2008C13.1498 16.5657 12.6349 16.0508 11.9998 16.0508C11.3647 16.0508 10.8498 16.5657 10.8498 17.2008Z",
    fill: "#121619"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8499 11.9996C10.8499 12.6347 11.3648 13.1496 11.9999 13.1496C12.635 13.1496 13.1499 12.6347 13.1499 11.9996C13.1499 11.3645 12.635 10.8496 11.9999 10.8496C11.3648 10.8496 10.8499 11.3645 10.8499 11.9996Z",
    fill: "#121619"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoreHorizonLight);
export default __webpack_public_path__ + "static/media/icon_more_horizon_light.931a3ae3.svg";
export { ForwardRef as ReactComponent };